<template>
  <b-input-group>
    <b-datepicker
      :style="{'background-color':'#515b65'}"
      :value="value"
      :date-format-options="{
        year: '2-digit',
        month: '2-digit',
        day: '2-digit',
      }"
      :label-no-date-selected="placeholder"
      reset-button
      hide-header
      start-weekday="1"
      dark
      @input="$emit('input', $event)"
    />
    <b-input-group-append>
      <b-button 
        variant="secondary"
        @click="$emit('input', null)"
      >
        <font-awesome-icon icon="times" />
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>
  <script>
  
  export default {
    name: "DateInputField",
    
    props: {
      value: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: 'Kies een datum'
      }
    },
  };
  </script>